export const GET_REPORTS_CASH_REGISTER_SESSION_DETAIL_ALL =
  'providers/reports/CashRegisterSessionDetail/GET_REPORTS_CASH_REGISTER_SESSION_DETAIL_ALL';
